import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SupportComponent } from 'src/app/component/support/support.component';
import { ResourcesComponent } from 'src/app/component/resources/resources.component';
import { UserInfoComponent } from 'src/app/component/user/user-info/user-info.component';
import { UserSettingsComponent } from 'src/app/component/user/settings/settings.component';
import { ProjectComponent } from 'src/app/component/project/project.component';
import { CommonModule } from 'src/app/common/common.module';
import { IntroComponent } from 'src/app/component/intro/intro.component';
import { TimeoutComponent } from 'src/app/component/timeout/timeout.component';
import { EmailInviteComponent } from 'src/app/component/project/project-detail/project-member/email-invite/email-invite.component';
import { ErrorComponent } from 'src/app/component/error/error.component';
import { ClientMigrationComponent } from 'src/app/component/project/client-migration/client-migration.component';
import { AuthGuardService } from 'src/app/service/guards/auth-guard.service';
import { CookieService } from 'ngx-cookie-service';
import { DesignSystemModule } from '@sdc-design-system/design-system';

// canLoad - allow to preload lazy module (with guard rules)
// canActivated - allow to access a route (with guard rules)
export const layoutRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'intro' },
  { path: 'intro', component: IntroComponent },
  {
    path: 'project',
    component: ProjectComponent,
    loadChildren: () => import('src/app/component/project/project.module').then((m) => m.ProjectModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'resources',
    component: ResourcesComponent,
    loadChildren: () => import('src/app/component/resources/resources.module').then((m) => m.ResourcesModule),
  },
  {
    path: 'support',
    component: SupportComponent,
  },
  {
    path: 'user',
    component: UserInfoComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'user/settings',
    component: UserSettingsComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'email-invite/:id/:memberType',
    component: EmailInviteComponent,
  },
  {
    path: 'timeout',
    component: TimeoutComponent,
  },
  {
    path: ':path',
    component: ErrorComponent,
  },
];

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, RouterModule.forChild(layoutRoutes), DesignSystemModule],
  declarations: [
    IntroComponent,
    ClientMigrationComponent,
    ProjectComponent,
    UserInfoComponent,
    UserSettingsComponent,
    ResourcesComponent,
    SupportComponent,
    TimeoutComponent,
    EmailInviteComponent,
    ErrorComponent,
  ],
  providers: [CookieService],
})
export class LayoutModule {}
